<div class="container py-3">
  @if (isLoading) {
    <ziro-loading-block></ziro-loading-block>
  }

  @if (!isLoading) {
    <ziro-breadcrumbs></ziro-breadcrumbs>

    @if (attentionMessages.length) {
      <div
        class="alert alert-warning d-flex gap-2 mb-3"
        data-automation="ring-central-call-queue-teams-mapping-attention-banner"
      >
        <i [class]="ziroIcons.WARNING_TRIANGLE"></i>
        <div>
          <div class="fw-bold">
            {{ 'tkey;migrations.ring_central.call_queues.teams_mapping.attention_banner.title' | translate }}
          </div>
          @for (message of attentionMessages; track message) {
            <div data-automation="ring-central-call-queue-teams-mapping-attention-banner-message">{{ message }}</div>
          }
        </div>
      </div>
    }

    <ziro-ring-central-call-queue-teams-mapping-form
      [tenantId]="tenantId"
      [languageOptions]="languageOptions"
      [entity]="callQueueEntity"
      (ziroFormsUpdate$)="onFormUpdate($event)"
    ></ziro-ring-central-call-queue-teams-mapping-form>

    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;migrations.ring_central.call_queues.teams_mapping.audio_settings.title'"
      [icon]="ziroIcons.ANNOUNCEMENTS"
      [cssClass]="'mb-3'"
    >
      <div class="p-4 d-flex gap-4">
        <div class="flex-grow-1">
          <label class="d-block mb-1">
            {{ 'tkey;migrations.ring_central.call_queues.teams_mapping.audio_settings.greeting.label' | translate }}
          </label>
          @if (callQueue.audioInformation.greetingFilename) {
            @if (greetingPreviewUrl) {
              <div class="d-flex align-items-center gap-2">
                <audio
                  data-automation="ring-central-call-queue-teams-mapping-greeting-audio"
                  class="flex-grow-1"
                  controls
                  [src]="greetingPreviewUrl"
                  [title]="greetingDownloadName"
                ></audio>
                <a
                  data-automation="ring-central-call-queue-teams-mapping-greeting-audio-download"
                  [href]="greetingPreviewUrl"
                  [download]="greetingDownloadName"
                  class="btn btn-border btn-link p-0"
                >
                  <i [class]="ziroIcons.DOWNLOAD_SMALL + ' font-size-18'"></i>
                </a>
              </div>
            }
          } @else {
            <p class="text-muted mb-0" data-automation="ring-central-call-queue-teams-mapping-no-greeting-audio">
              {{ 'tkey;migrations.ring_central.call_queues.teams_mapping.audio_settings.no_audio' | translate }}
            </p>
          }
        </div>
        <div class="flex-grow-1">
          <label class="d-block mb-1">
            {{
              'tkey;migrations.ring_central.call_queues.teams_mapping.audio_settings.music_on_hold.label' | translate
            }}
          </label>
          @if (callQueue.audioInformation.musicOnHoldFilename) {
            @if (musicOnHoldPreviewUrl) {
              <div class="d-flex align-items-center gap-2">
                <audio
                  data-automation="ring-central-call-queue-teams-mapping-moh-audio"
                  class="flex-grow-1"
                  controls
                  [src]="musicOnHoldPreviewUrl"
                  [title]="musicOnHoldDownloadName"
                ></audio>
                <a
                  data-automation="ring-central-call-queue-teams-mapping-moh-audio-download"
                  [href]="musicOnHoldPreviewUrl"
                  [download]="musicOnHoldDownloadName"
                  class="btn btn-border btn-link p-0"
                >
                  <i [class]="ziroIcons.DOWNLOAD_SMALL + ' font-size-18'"></i>
                </a>
              </div>
            }
          } @else {
            <p class="text-muted mb-0" data-automation="ring-central-call-queue-teams-mapping-no-moh-audio">
              {{ 'tkey;migrations.ring_central.call_queues.teams_mapping.audio_settings.no_audio' | translate }}
            </p>
          }
        </div>
      </div>
    </ziro-collapsible-section-card>

    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [isCollapsible]="false"
      [title]="'tkey;migrations.ring_central.call_queues.teams_mapping.members.title'"
      [subtext]="'tkey;migrations.ring_central.call_queues.teams_mapping.members.description'"
      [icon]="ziroIcons.GROUP"
    >
      <ziro-datatable
        [dataAutomation]="'ring-central-call-queue-teams-mapping-members-table'"
        [columns]="memberColumns"
        [rowDataSource]="memberRows"
        [uniqueRowIdentifier]="'memberId'"
        [showValidationMessageInTooltip]="true"
        (validationUpdate)="onMembersValidationUpdate($event)"
        (rowFieldChanged)="onMemberTeamsUpnChange($event)"
      ></ziro-datatable>
    </ziro-collapsible-section-card>

    <ziro-collapsible-section-card
      [isSwitchHidden]="true"
      [removeExpandedClass]="true"
      [title]="'tkey;teams_call_queue.exception_handling.header'"
      [subtext]="getExceptionHandlingSubtext()"
      [icon]="ziroIcons.CIRCLE_EXCLAMATION"
      [isCollapsible]="false"
      [cssClass]="'mt-4'"
    >
      <div class="p-4">
        <ul
          ngbNav
          #exceptionNav="ngbNav"
          [destroyOnHide]="false"
          [(activeId)]="activeExceptionTab"
          class="nav-pills"
          data-automation="ring-central-call-queue-teams-mapping-exception-handling-nav-tabs"
        >
          <li [ngbNavItem]="ExceptionHandlingSectionType.OVERFLOW" [destroyOnHide]="false" class="col-4">
            <a ngbNavLink class="btn nav-link text-center" data-automation="exception-handling-overflow-tab">
              @if (
                exceptionTabsValidationState[ExceptionHandlingSectionType.OVERFLOW]() ===
                ZiroFormsValidationState.INVALID
              ) {
                <i [class]="ziroIcons.EXCLAMATION + ' fa fa-md icon-exclamation text-danger'"></i>
              }
              <span>{{ 'tkey;teams_call_queue.exception_handling.overflow.header' | translate }}</span>
            </a>
            <ng-template ngbNavContent>
              <ziro-call-queue-exception-handling-form
                #overflowForm
                [dataAutomation]="'ring-central-call-queue-teams-mapping-overflow-handling'"
                [sectionType]="ExceptionHandlingSectionType.OVERFLOW"
                [tenantId]="tenantId"
                [agentAlertTime]="getAgentAlertTime()"
                [entity]="uiOverflowSettings"
                (ziroFormsUpdate$)="setExceptionHandlingSettings($event, 'uiOverflowSettings')"
              ></ziro-call-queue-exception-handling-form>
            </ng-template>
          </li>
          <li [ngbNavItem]="ExceptionHandlingSectionType.TIMEOUT" [destroyOnHide]="false" class="col-4">
            <a ngbNavLink class="btn nav-link text-center" data-automation="exception-handling-timeout-tab">
              @if (
                exceptionTabsValidationState[ExceptionHandlingSectionType.TIMEOUT]() ===
                ZiroFormsValidationState.INVALID
              ) {
                <i [class]="ziroIcons.EXCLAMATION + ' fa fa-md icon-exclamation text-danger'"></i>
              }
              <span>{{ 'tkey;teams_call_queue.exception_handling.timeout.header' | translate }}</span>
            </a>
            <ng-template ngbNavContent>
              <ziro-call-queue-exception-handling-form
                #timeoutForm
                [dataAutomation]="'ring-central-call-queue-teams-mapping-timeout-handling'"
                [sectionType]="ExceptionHandlingSectionType.TIMEOUT"
                [tenantId]="tenantId"
                [agentAlertTime]="getAgentAlertTime()"
                [entity]="uiTimeoutSettings"
                (ziroFormsUpdate$)="setExceptionHandlingSettings($event, 'uiTimeoutSettings')"
              ></ziro-call-queue-exception-handling-form>
            </ng-template>
          </li>
          <li [ngbNavItem]="ExceptionHandlingSectionType.NO_AGENTS" [destroyOnHide]="false" class="col-4">
            <a ngbNavLink class="btn nav-link text-center" data-automation="exception-handling-no-agents-tab">
              @if (
                exceptionTabsValidationState[ExceptionHandlingSectionType.NO_AGENTS]() ===
                ZiroFormsValidationState.INVALID
              ) {
                <i [class]="ziroIcons.EXCLAMATION + ' fa fa-md icon-exclamation text-danger'"></i>
              }
              <span>{{ 'tkey;teams_call_queue.exception_handling.no_agents.header' | translate }}</span>
            </a>
            <ng-template ngbNavContent>
              <ziro-call-queue-exception-handling-form
                #noAgentsForm
                [dataAutomation]="'ring-central-call-queue-teams-mapping-no-agents-handling'"
                [sectionType]="ExceptionHandlingSectionType.NO_AGENTS"
                [tenantId]="tenantId"
                [agentAlertTime]="getAgentAlertTime()"
                [entity]="uiNoAgentSettings"
                (ziroFormsUpdate$)="setExceptionHandlingSettings($event, 'uiNoAgentSettings')"
              ></ziro-call-queue-exception-handling-form>
            </ng-template>
          </li>
        </ul>
        <div [ngbNavOutlet]="exceptionNav" class="mt-2 tab-content"></div>
      </div>
    </ziro-collapsible-section-card>
  }
</div>
